import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '../reset-password/reset-password.styles';

import { Button, Stack, Typography } from '@mui/material';
import { usePageTitle } from 'hooks/usePageTitle.hooks';
import { Helmet } from 'react-helmet';
import { useOptOutEmail } from './unsubscribe.hooks';

const Unsubscribe = () => {
  const { t } = useTranslation();
  const { success, loading, optOutEmail } = useOptOutEmail();
  const title = usePageTitle(t('head.title.unsubscribe'));

  return (
    <S.Container data-testid={'Unsubscribe.Container'}>
      <S.ContentContainer elevation={2}>
        <Helmet title={title} />
        <S.ContentHeader
          component="h1"
          variant="h5"
          data-testid={'Unsubscribe.Title'}
        >
          {t('unsubscribe.title')}
        </S.ContentHeader>
        <S.ContentBody>
          {success ? (
            <Typography data-testid={'Unsubscribe.Description'}>
              {t('optOut.description')}
            </Typography>
          ) : (
            <Stack spacing={1}>
              <Typography
                data-testid={'Unsubscribe.Description'}
                textAlign="center"
              >
                {t('unsubscribe.description')}
              </Typography>
              <Button
                variant="contained"
                onClick={optOutEmail}
                disabled={loading}
                data-testid="Unsubscribe.Button"
              >
                {t('unsubscribe.button.label')}
              </Button>
            </Stack>
          )}
        </S.ContentBody>
      </S.ContentContainer>
    </S.Container>
  );
};

export default Unsubscribe;
